// Configuration template for Insite Support Tools

export const apiHost = 'https://dev.simbexdevops.com/api/v1';

// Example API host configurations
// export const apiHost = 'https://dev.mydomain.com/api';
// export const apiHost = 'https://qa.mydomain.com/api';

declare const process: {
  env: Record<string, string | undefined>
}

const envValue = (key: string): string | undefined => {
  const value = process.env[key]
  if (typeof value !== 'string') return undefined
  const trimmed = value.trim()
  return trimmed.length > 0 ? trimmed : undefined
}

// Dashboard configuration type
export interface Dashboard {
  id: string
  title: string
  url: string
  sandbox?: string
}

// Dashboards available in the Support Dashboards tool
// URLs can be overridden via environment variables without a code change.
export const DASHBOARDS: Dashboard[] = [
  {
    id: 'overall-status',
    title: 'Overall Status Dashboard',
    url:
      envValue('REACT_APP_SUPPORT_DASHBOARD_OVERALL_URL') ??
      'https://datastudio.google.com/embed/reporting/56478b42-8913-40bc-aa88-8a1ff9f5f1bf/page/YN8xF',
    sandbox: 'allow-same-origin allow-scripts'
  },
  {
    id: 'daily-weekly',
    title: 'Daily and Weekly Reports',
    url:
      envValue('REACT_APP_SUPPORT_DASHBOARD_DAILY_WEEKLY_URL') ??
      'https://datastudio.google.com/embed/reporting/17950c96-2a3f-4fe3-b294-043cc0e14305/page/p_mf5yhfdmwd'
  }
]

// Default dashboard to display when the tool first loads
export const DEFAULT_DASHBOARD_ID = 'overall-status'

// Maximum number of dashboards that can be displayed simultaneously
export const MAX_SELECTIONS = 2